// import moment
import momentTz from 'moment-timezone';
import moment from 'moment';

// impor tfilepond
import { registerPlugin } from 'react-filepond';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

// configure moment
momentTz.tz.setDefault('America/Los_Angeles');
(moment as any).tz.setDefault('America/Los_Angeles');

moment.updateLocale('en', {
  invalidDate: '',
});

// configure filepond
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
  FilePondPluginFilePoster
);
